// extracted by mini-css-extract-plugin
export var labelWrapper = "_eg-0";